export default __webpack_public_path__ + "static/media/philosophyDeco.9a5e14f3.png";